import React from 'react'
import { PolicyLayout } from '../../shared/PolicyLayout'
import { P } from '../../shared/P'
import Footer from '../components/Footer'

export default function Refund() {
  return <><PolicyLayout title="Refund Policy" icon="💰" sub="We stand behind every order">
  <div className="bg-green-50 border border-green-200 rounded-2xl p-5 text-sm text-green-800 font-medium">Not happy? Neither are we. Contact us within 30 minutes and we'll make it right — always.</div>
  <P title="Eligible for Refund">Wrong item received · Food quality below standard · Significant delay beyond 60 minutes · Order arrived damaged</P>
  <P title="How to Claim">Open the app → My Orders → Select order → Report Issue. Or call +91 98765 43210. Attach photos if possible. We respond within 2 hours.</P>
  <P title="Refund Timeline">Bank/Card: 3–5 business days · UPI: 1–2 business days · Cash on Delivery: Store credit within 24 hours</P>
  <P title="Partial Refunds">For partially affected orders, we refund the proportional value of affected items or offer a replacement on your next order.</P>
  <P title="Not Eligible">Change of mind after preparation · Incorrect address provided · Order delayed but within 45 minutes · Spice level subjective preferences</P>
</PolicyLayout>
 <Footer />
  </>
}
